
import { defineComponent, ref } from 'vue';
import useRequest from '@/composables/useRequest';
import { PasswordTokenAuthenticationRequest } from '@/data/requests/PasswordTokenAuthenticationRequest';
import { OAuthToken } from '@/data/models/OAuthToken';
import SHA512 from 'sha512-es';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import ButtonElement from '@/components/ButtonElement.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();

    const password = ref<string>();

    const router = useRouter();

    const store = useStore();

    const { loading, error, request, execute } = useRequest<PasswordTokenAuthenticationRequest, OAuthToken>(
      new PasswordTokenAuthenticationRequest(),
      t('errors.authentication.invalid_credentials')
    );

    const submitLogin = () => {
      request.value.data.password = SHA512.hash(password.value);
      request.value.data.sport = 'kite';

      execute().then((response) => {
        store.commit('setToken', { token: response });

        const path = router.currentRoute.value.query?.path as undefined | string;

        if (path) {
          router.push(path);
        } else {
          router.push({ name: 'authenticated.home' });
        }
      });
    };

    return {
      request,
      password,
      submitLogin,
      loading,
      error,
    };
  },

  components: {
    ButtonElement,
  },
});
